import { useAuthService } from "@src/ducks/hooks";
import { largeSize, tabletSize, mobileSize } from "@src/utils/screensize-helper";
import { LinearGradient } from "expo-linear-gradient";
import React, { useContext } from "react";
import { ScrollView, View } from "react-native";
import Animated, {
  Extrapolation,
  interpolate,
  useAnimatedStyle,
} from "react-native-reanimated";
import CopyRightContent from "./copy-right";
import DrawerList from "./drawer-list";
import DrawerItem from "./drawer-list/drawer-item";
import FloatingButton from "./floating-button";
import DrawerHeader from "./header";
import { DrawerComponentContext } from "./provider";
import useStyles from "./styles.css";

const DrawerComponentScreen = () => {
  const styles = useStyles();
  const isLargeSize = largeSize();
  const isTabletSize = tabletSize();
  const isMobileSize = mobileSize();
  const { onLogout } = useAuthService();
  const { animated, isMinimize } = useContext(DrawerComponentContext);

  const animateStyle = useAnimatedStyle(() => {
    const translateX = interpolate(
      animated.value,
      [360, 110],
      [0, isMobileSize ? -380 : isTabletSize ? -380 : 0],
      Extrapolation.CLAMP,
    );

    const width = interpolate(
      animated.value,
      [360, 110],
      [360, isTabletSize ? 0 : isLargeSize ? 81.15 : 110],
      Extrapolation.CLAMP,
    );

    return { 
      width,
      position: isTabletSize ? "absolute" : "relative",
      transform: [{ translateX }] 
    };
  }, [isMobileSize, isTabletSize, isLargeSize, ]);

  const animatePaddingLeft = useAnimatedStyle(() => {
    const paddingLeft = interpolate(
      animated.value,
      [360, 110],
      [isLargeSize ? 22.5 : 30, isLargeSize ? 11.25 : 15],
      Extrapolation.CLAMP,
    );
    return {
      paddingLeft
    };
  }, [isLargeSize]);

  return (
    <Animated.View pointerEvents="box-none" style={[styles.v_drawer_container, animateStyle ]}>
      <LinearGradient
        colors={isTabletSize ? ["#F9F9F9", "#F9F9F9", "#F9F9F9"] : ["#1C242C", "#1C242C", "#1C242C"]}
        style={[styles.linear_style]}
      />
      <Animated.View style={[styles.linear_style, animatePaddingLeft]}>
        <ScrollView>
          { !isTabletSize && <DrawerHeader /> }
          <DrawerList />
          <View style={styles.v_height} />
          { isTabletSize && 
            <DrawerItem
              item={{
                name: isMinimize ? "" : "Logout",
                icon: "Logout",
              }}
              style={[styles.drawer_logout]}
              onPress={onLogout}
            />
          }

          { !isTabletSize && 
          <DrawerItem
            item={{
              name: isMinimize ? "" : "Logout",
              icon: "Logout",
            }}
            // style={[styles.drawer_logout]}
            onPress={onLogout}
          />
        }

          { isMobileSize && !isMinimize && <CopyRightContent /> }
        </ScrollView>
        
        {!isMobileSize && !isMinimize && <CopyRightContent /> }
      </Animated.View>
      { !isTabletSize && <FloatingButton /> }
    </Animated.View>
  );
};

export default React.memo(DrawerComponentScreen);
